import React from 'react'
import { useViewport } from '@chilecompra/react-kit'
import { Typography } from '@chilecompra/react-kit/components'
import { Content, GridContainer, GridItem, Root } from './HomeHeadingsProducts.styles'

/**
 * The HomeHeadingsProducts's container.
 */
const HomeHeadingsProducts = () => {
  const { size } = useViewport()

  return (
    <Root>
      <Content>
        <GridContainer>
          <GridItem xs={12} md={6}>
            <Typography
              color="primary"
              fontSize="18px"
              fontWeight="bold"
              lineHeight="21px"
              margin={size.isUpToMedium ? '96px 0 0' : '24px 0'}
              variant="body1"
            >
              Ventas en la plataforma
            </Typography>
            <Typography
              fontSize="34px"
              fontWeight="bold"
              lineHeight="38px"
              margin={size.isUpToMedium ? '12px 0' : '0'}
              variant="h2"
              width={size.isUpToMedium ? '485px' : undefined}
            >
              Rubros y productos transados en Mercado Público
            </Typography>
            <Typography
              fontSize="18px"
              lineHeight="24px"
              margin={size.isUpToMedium ? '0' : '24px 0'}
              variant="body1"
              width={size.isUpToMedium ? '448px' : undefined}
            >
              Cónoce cuales son los productos o servicios más comprados por el Estado.
            </Typography>
          </GridItem>
        </GridContainer>
      </Content>
    </Root>
  )
}

export default HomeHeadingsProducts
